module.exports = __webpack_public_path__ + "static/media/Card_PO.38688a7d.svg";